<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <div class="grid grid-cols-2 gap-4 mb-2">
            <div class="col-span-2">
                <my-input
                    v-model="form.title"
                    name="title"
                    :error="form.errors.get('title')"
                    :autofucos="true"
                    label="Project Title"
                    placeholder="e.g. Logo Design"
                />
            </div>
            <div class="col-span-2">
                <rich-editor
                    v-model="form.description"
                    label="Project Description"
                    placeholder="Describe your project here..."
                    :error="form.errors.get('description')"
                />
            </div>
        </div>
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        updateRec: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            fields: ['title', 'description'],
            form: null
        };
    },

    mounted() {
        this.initForm();
    },

    methods: {
        initForm() {
            let formData = {};

            if (this.updateRec) {
                this.fields.forEach(field => (formData[field] = this.updateRec[field]));
            } else {
                this.fields.forEach(field => (formData[field] = null));
            }

            this.form = new Form(formData);
            this.form.no_expiration = false;
        },

        submit() {
            let uri = this.updateRec ? `/api/profile-projects/${this.updateRec.id}` : `/api/profile-projects`;

            return new Promise((resolve, reject) => {
                this.form
                    .post(uri)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
